class ShopifyTheme {
  static EVENTS = {
    COOKIE_CONSENT: 'cookie:consent',
    COOKIE_CLOSED: 'cookie:closed',
  };
  static STORAGE = {
    COOKIE_CONSENT: 'cookie_consent',
  };

  static loadCustomerPrivacy = () => {
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      error => {
        if (error) {
          throw new Error(error);
        } /*else {
          window.Shopify.customerPrivacy.setTrackingConsent(false, () => {
            console.log('Tracking consent set to false', window.Shopify.customerPrivacy.userCanBeTracked());
          });
        }*/
      }
    );
  }

  static iubendaIntegration = (preferences) => {
    const isPrefEmpty = !preferences || Object.keys(preferences).length === 0;
    const consent = isPrefEmpty ? _iub.cs.api.getPreferences() : preferences;
    const shopifyPurposes = {
      "analytics": [4, 's'],
      "marketing": [5, 'adv'],
      "preferences": [2, 3],
      "sale_of_data": ['s', 'sh'],
    }
    const expressedConsent = {};
    Object.keys(shopifyPurposes).forEach(function(purposeItem) {
      var purposeExpressed = null
      shopifyPurposes[purposeItem].forEach(item => {
        if (consent.purposes && typeof consent.purposes[item] === 'boolean') {
          purposeExpressed = consent.purposes[item];
        }
        if (consent.uspr && typeof consent.uspr[item] === 'boolean' && purposeExpressed !== false) {
          purposeExpressed = consent.uspr[item];
        }
      })

      if (typeof purposeExpressed === 'boolean') {
        expressedConsent[purposeItem] = purposeExpressed;
      }
    });
    localStorage.setItem(ShopifyTheme.STORAGE.COOKIE_CONSENT, JSON.stringify(expressedConsent));
    window.Shopify.customerPrivacy.setTrackingConsent(expressedConsent);
    ShopifyTheme.customEvent(ShopifyTheme.EVENTS.COOKIE_CONSENT, expressedConsent);
  }

  static customEvent = (eventName, data) => {
    window.dispatchEvent(new CustomEvent(eventName, {
      detail: data
    }));
    Shopify.analytics.publish(eventName, data);
  }

  static isPreferencesAllowed = () => {
    const consent = JSON.parse(localStorage.getItem(ShopifyTheme.STORAGE.COOKIE_CONSENT));
    return consent && consent.preferences;
  }

  static isMarketingAllowed = () => {
    const consent = JSON.parse(localStorage.getItem(ShopifyTheme.STORAGE.COOKIE_CONSENT));
    return consent && consent.marketing;
  }

  static isAnalyticsAllowed = () => {
    const consent = JSON.parse(localStorage.getItem(ShopifyTheme.STORAGE.COOKIE_CONSENT));
    return consent && consent.analytics;
  }
}

/*
class ShopifyTheme {
  static EVENTS = {
    COOKIE_CONSENT: 'cookie:consent',
    COOKIE_CLOSED: 'cookie:closed',
  };
  static STORAGE = {
    COOKIE_CONSENT: 'cookie_consent',
  };

  // readiness flag + queue
  static _customerPrivacyReady = false;
  static _consentQueue = [];

  static loadCustomerPrivacy = () => {
    console.log('[Consent][Shopify] loadCustomerPrivacy() called');

    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      error => {
        if (error) {
          console.error(
            '[Consent][Shopify] Failed to load Customer Privacy API',
            error
          );
          return;
        }

        console.log('[Consent][Shopify] Customer Privacy API loaded');

        ShopifyTheme._customerPrivacyReady = true;

        // Flush queued consents
        if (ShopifyTheme._consentQueue.length > 0) {
          console.log(
            `[Consent][Shopify] Flushing ${ShopifyTheme._consentQueue.length} queued consent(s)`
          );

          ShopifyTheme._consentQueue.forEach((preferences, index) => {
            console.log(
              `[Consent][Shopify] Applying queued consent #${index + 1}`,
              preferences
            );
            try {
              ShopifyTheme.iubendaIntegration(preferences);
            } catch (e) {
              console.error(
                '[Consent][Shopify] Error applying queued consent',
                e
              );
            }
          });

          ShopifyTheme._consentQueue = [];
        }
      }
    );
  }

  static iubendaIntegration = (preferences) => {
    console.log('[Consent][Iubenda] iubendaIntegration called', preferences);

    // Prevent race condition
    if (
      !ShopifyTheme._customerPrivacyReady ||
      !window.Shopify?.customerPrivacy?.setTrackingConsent
    ) {
      console.log(
        '[Consent][Shopify] Customer Privacy API not ready → queueing consent'
      );
      ShopifyTheme._consentQueue.push(preferences);
      return;
    }

    const isPrefEmpty = !preferences || Object.keys(preferences).length === 0;
    const consent = isPrefEmpty
      ? _iub.cs.api.getPreferences()
      : preferences;

    console.log('[Consent][Iubenda] Normalized consent object', consent);

    const shopifyPurposes = {
      analytics: [4, 's'],
      marketing: [5, 'adv'],
      preferences: [2, 3],
      sale_of_data: ['s', 'sh'],
    };

    const expressedConsent = {};

    Object.keys(shopifyPurposes).forEach(function (purposeItem) {
      let purposeExpressed = null;

      shopifyPurposes[purposeItem].forEach(item => {
        if (
          consent.purposes &&
          typeof consent.purposes[item] === 'boolean'
        ) {
          purposeExpressed = consent.purposes[item];
        }

        if (
          consent.uspr &&
          typeof consent.uspr[item] === 'boolean' &&
          purposeExpressed !== false
        ) {
          purposeExpressed = consent.uspr[item];
        }
      });

      if (typeof purposeExpressed === 'boolean') {
        expressedConsent[purposeItem] = purposeExpressed;
      }
    });

    console.log(
      '[Consent][Shopify] Mapped consent → Shopify format',
      expressedConsent
    );

    localStorage.setItem(
      ShopifyTheme.STORAGE.COOKIE_CONSENT,
      JSON.stringify(expressedConsent)
    );

    console.log(
      '[Consent][Shopify] Calling setTrackingConsent',
      expressedConsent
    );

    window.Shopify.customerPrivacy.setTrackingConsent(expressedConsent);

    ShopifyTheme.customEvent(
      ShopifyTheme.EVENTS.COOKIE_CONSENT,
      expressedConsent
    );
  }

  static customEvent = (eventName, data) => {
    console.log(
      `[Consent][Event] Dispatching custom event: ${eventName}`,
      data
    );

    window.dispatchEvent(
      new CustomEvent(eventName, { detail: data })
    );

    Shopify.analytics.publish(eventName, data);
  }

  static isPreferencesAllowed = () => {
    const consent = JSON.parse(
      localStorage.getItem(ShopifyTheme.STORAGE.COOKIE_CONSENT)
    );
    console.log('[Consent][Check] preferences allowed?', consent?.preferences);
    return consent && consent.preferences;
  };

  static isMarketingAllowed = () => {
    const consent = JSON.parse(
      localStorage.getItem(ShopifyTheme.STORAGE.COOKIE_CONSENT)
    );
    console.log('[Consent][Check] marketing allowed?', consent?.marketing);
    return consent && consent.marketing;
  };

  static isAnalyticsAllowed = () => {
    const consent = JSON.parse(
      localStorage.getItem(ShopifyTheme.STORAGE.COOKIE_CONSENT)
    );
    console.log('[Consent][Check] analytics allowed?', consent?.analytics);
    return consent && consent.analytics;
  };
}
*/